const getUser = state => {
	return state.user;
}

export { getUser }
